// extracted by css-extract-rspack-plugin
export default {"toast":"Te1zt","icon":"WwIRB","body":"gLGT1","message":"vxWvZ","dismiss":"B8UEE"};